const toHex = (number) => number.toString(16).padStart(2, "0");
function classNames(value) {
    if (!value) {
        return [];
    }
    if (typeof value === "string" || typeof value === "number") {
        return [String(value)];
    }
    if (Array.isArray(value)) {
        return value.flatMap(classNames);
    }
    if (typeof value === "object") {
        return Object.entries(value)
            .filter(([, enabled]) => Boolean(enabled))
            .map(([className]) => className);
    }
    return [];
}
export function cn(...inputs) {
    return inputs.flatMap(classNames).join(" ");
}
export function safeRandomId() {
    const cryptoApi = typeof globalThis !== "undefined" && "crypto" in globalThis
        ? globalThis.crypto
        : undefined;
    if (cryptoApi && typeof cryptoApi.randomUUID === "function") {
        return cryptoApi.randomUUID();
    }
    if (cryptoApi && typeof cryptoApi.getRandomValues === "function") {
        const bytes = new Uint8Array(16);
        cryptoApi.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;
        const hex = Array.from(bytes, toHex).join("");
        return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    }
    return `lp-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
}
